const PUBLIC_ROUTES = [
    { url: '/', redirectLogin: true, requiresNegocio: true },
    { url: '/ecommerce/estadoPedido', redirectLogin: false, requiresNegocio: false },
    { url: '/login-handy', redirectLogin: false, requiresNegocio: false }
    // Agrega más rutas según lo necesites
];

export default PUBLIC_ROUTES;
